import type { ConfigurationRow } from '../../releasegovernance/framework';

type Props = { items?: ConfigurationRow[] };

export function ConfigurationManagementPanel({ items = [] }: Props) {
  return (
    <div className="space-y-2">
      {items.map((item) => (
        <div key={`${item.domain}-${item.control}`} className="rounded-lg border border-slate-200 p-3 dark:border-slate-700">
          <p className="text-xs text-slate-400">{item.domain}</p>
          <div className="flex items-center justify-between gap-3">
            <p className="text-sm font-medium">{item.control}</p>
            <span className="shrink-0 rounded-full bg-emerald-50 px-2 py-0.5 text-xs font-medium text-emerald-700 dark:bg-emerald-950 dark:text-emerald-300">
              {item.status}
            </span>
          </div>
        </div>
      ))}
    </div>
  );
}
